<template>
  <div class="box-detail product">
    <div class="box-left">
      <div class="box-left-header">
        <div
          @click="$router.push({ path: '/Products' + (type ? `?type=${type}` : '') })"
          class="goBack c-position-static c-m-0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>{{ typeName }}列表</span>
          <i class="el-icon-box"></i>
        </div>
        <div class="c-m-r-10">
          <el-tag effect="plain" v-if="formData.productState == '0'">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '1'">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '3'" type="success">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '4'" type="danger">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState" type="info">
            {{ formatProductState(formData.productState) }}
          </el-tag>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="110px"
          @changeForm="osg.changeForm"
        >
          <!-- <el-form-item label="产品图片" v-show="false">
            <el-upload
              :action="upload.url"
              :data="upload.data"
              :file-list="formData.image"
              multiple
              list-type="picture-card"
              :limit="10"
              :on-exceed="osg.uploadExceed"
              :before-upload="
                file => {
                  return osg.beforeUpload(file, 'image');
                }
              "
              :on-success="
                (response, file, fileList) => {
                  return osg.uploadSuccess(response, file, fileList, 'image');
                }
              "
              :on-error="osg.uploadError"
              :on-remove="
                (file, fileList) => {
                  return osg.beforeRemove(file, fileList, 'image');
                }
              "
              :on-preview="osg.uploadPreview"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog
              :modal="false"
              custom-class="dialog-img"
              :visible.sync="upload.dialogVisible"
            >
              <img width="100%" :src="upload.dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item> -->
          <template slot="workflowDefId">
            <el-select
              v-model="formData.workflowDefId"
              clearable
              @change="$forceUpdate()"
              filterable
              remote
              :remote-method="getWorkflowDef"
              @clear="getWorkflowDef"
              placeholder="可输入服务流程名称搜索查询"
            >
              <el-option
                v-for="item in options.workflowDef"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="depends">
            <el-select
              v-model="formData.depends"
              multiple
              clearable
              @change="$forceUpdate()"
              filterable
              remote
              :remote-method="getProduct"
              @clear="getProduct"
              reserve-keyword
              placeholder="可输入产品名称搜索查询"
            >
              <el-option
                v-for="item in options.product"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item._id == id"
              ></el-option>
            </el-select>
          </template>
          <template slot="childs">
            <el-select
              v-model="formData.childs"
              multiple
              clearable
              @change="$forceUpdate()"
              filterable
              remote
              :remote-method="getProduct"
              @clear="getProduct"
              reserve-keyword
              placeholder="可输入产品名称搜索查询"
            >
              <el-option
                v-for="item in options.product"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item._id == id"
              ></el-option>
            </el-select>
          </template>
          <!-- TODO:业务类型 -->
          <el-form-item label="业务类型" v-if="tenantId != '1340835581184723420'">
            <el-select v-model="formData.productBizType" clearable>
              <el-option
                v-for="item in options.productBizType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave()">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="关联材料" name="material" v-if="osg.has('Product,material')">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openNotAddMaterial">
                添加材料
              </el-button>
            </div>
          </div>
          <el-table ref="addedTable" :data="material.addedFpi.data" border class="c-m-t-10">
            <el-table-column label="名称" fixed width="250px" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="$router.push({ path: `/Material/${scope.row._id}` })"
                  type="text"
                >
                  {{ scope.row.name }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="编号" width="140px"></el-table-column>
            <el-table-column prop="spec" label="规格"></el-table-column>
            <el-table-column prop="model" label="型号"></el-table-column>
            <el-table-column prop="price" label="售价C(元)"></el-table-column>
            <el-table-column label="材料消耗量" width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.editable">
                  <el-input-number
                    v-model="scope.row.consumption"
                    :min="0"
                    :controls="false"
                    :precision="2"
                    style="width:100%;box-sizing:border-box;"
                  ></el-input-number>
                </template>
                <template v-else>
                  <span>{{ scope.row.consumption }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="materialUnit"
              label="单位"
              :formatter="formatUnits"
            ></el-table-column>
            <el-table-column label="是否默认选中" width="130">
              <template slot-scope="scope">
                <template v-if="scope.row.editable">
                  <el-radio-group v-model="scope.row.default" class="c-radio-group">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <span>{{ scope.row.default ? '是' : '否' }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="150" label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.editable"
                  @click="materialSave(scope.row)"
                  size="mini"
                  type="success"
                >
                  保存
                </el-button>
                <el-button v-else @click="materialEdit(scope.row)" size="mini">
                  编辑
                </el-button>
                <el-button @click="materialDelete(scope.row, scope.$index)" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            title="未添加材料列表"
            :visible.sync="material.open"
            custom-class="c-dialog c-min-height-80vh c-min-width-600"
            @close="cancelMaterials"
          >
            <div class="c-flex c-flex-between">
              <div>
                <p v-if="material.selectedRows.length > 0">
                  已选中
                  <span class="c_blue">{{ material.selectedRows.length }}</span>
                  项
                </p>
              </div>
              <el-input
                class="search-input c-fr"
                placeholder="请输入材料名称/编号"
                v-model="material.searchValue"
                clearable
                @clear="
                  selectMaterials();
                  material.notAddedFpi.page = 1;
                  getNotAddedMaterials();
                "
                @keyup.enter.native="
                  selectMaterials();
                  material.notAddedFpi.page = 1;
                  getNotAddedMaterials();
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    selectMaterials();
                    material.notAddedFpi.page = 1;
                    getNotAddedMaterials();
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="notAddedTable"
              :data="material.notAddedFpi.data"
              empty-text="没有查询到未添加的材料"
              :row-key="getRowKey"
              @selection-change="selectMaterials"
              height="100px"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                fixed
                show-overflow-tooltip
              ></el-table-column>
              <!-- <el-table-column prop="code" label="编号"></el-table-column>
              <el-table-column prop="spec" label="规格"></el-table-column>
              <el-table-column prop="model" label="型号"></el-table-column>
              <el-table-column prop="price" label="售价C(元)"></el-table-column>
              <el-table-column
                prop="materialUnit"
                label="单位"
                :formatter="formatUnit"
              ></el-table-column> -->
            </el-table>
            <div slot="footer" class="c-flex c-flex-between c-flex-item">
              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="material.notAddedFpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="material.notAddedFpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="material.notAddedFpi.total"
              ></el-pagination>
              <div class="c-flex">
                <el-button type="primary" @click="addMaterials">确 定</el-button>
                <el-button @click="cancelMaterials">取 消</el-button>
              </div>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="服务工序" name="procedure" v-if="osg.has('Product,procedure')">
          <div class="box-center-tool">
            <div>
              <el-tag type="danger" style="margin-bottom:10px">
                清工定额：¥
                {{ laborCost || 0 }}（清工定额即所有工序清工定额的总和，每道工序清工定额 = 劳务定额
                * 劳务消耗）
              </el-tag>
              <el-tag type="danger">
                清工单价：¥
                {{ laborFee || 0 }}（清工单价即所有工序清工单价的总和，每道工序清工单价 = 劳务价格 *
                劳务消耗）
              </el-tag>
            </div>
            <div>
              <el-button type="primary" size="mini" @click="openProcedure">
                添加工序
              </el-button>
            </div>
          </div>
          <el-table ref="addedProcedures" :data="procedure.addedFpi.data" border class="c-m-t-10">
            <el-table-column
              prop="name"
              label="名称"
              fixed
              width="150px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="consumption" label="劳务消耗"></el-table-column>
            <el-table-column label="劳务定额(元)" width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.editable">
                  <el-input-number
                    v-model="scope.row.laborCost"
                    :min="0"
                    :controls="false"
                    :precision="2"
                    style="width:100%;box-sizing:border-box;"
                  ></el-input-number>
                </template>
                <template v-else>
                  <span>{{ scope.row.laborCost }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="劳务价格(元)" width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.editable">
                  <el-input-number
                    v-model="scope.row.laborFee"
                    :min="0"
                    :controls="false"
                    :precision="2"
                    style="width:100%;box-sizing:border-box;"
                  ></el-input-number>
                </template>
                <template v-else>
                  <span>{{ scope.row.laborFee }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="是否在移动端展示" width="130">
              <template slot-scope="scope">
                <template v-if="scope.row.editable">
                  <el-radio-group v-model="scope.row.show" class="c-radio-group">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <span>{{ scope.row.show ? '是' : '否' }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="编号"></el-table-column>
            <el-table-column label="适用部位" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatCascadeMultiple('repairParts', scope.row.part) }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="150" label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.editable"
                  @click="procedureSave(scope.row)"
                  size="mini"
                  type="success"
                >
                  保存
                </el-button>
                <el-button v-else @click="procedureEdit(scope.row)" size="mini">
                  编辑
                </el-button>
                <el-button @click="procedureDelete(scope.row, scope.$index)" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            title="添加工序"
            :visible.sync="procedure.open"
            custom-class="c-dialog c-min-height-80vh"
            @close="cancelProcedures"
          >
            <div class="c-flex c-flex-between c-flex-item">
              <div>
                <p v-if="procedure.selectedRows.length > 0">
                  已选中
                  <span class="c_blue">{{ procedure.selectedRows.length }}</span>
                  项
                </p>
              </div>
              <el-input
                class="search-input c-fr"
                placeholder="请输入工序名称/编号"
                v-model="procedure.searchValue"
                clearable
                @clear="
                  selectProcedures();
                  procedure.fpi.page = 1;
                  getProcedures();
                "
                @keyup.enter.native="
                  selectProcedures();
                  procedure.fpi.page = 1;
                  getProcedures();
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    selectProcedures();
                    procedure.fpi.page = 1;
                    getProcedures();
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="procedures"
              :data="procedure.fpi.data"
              empty-text="没有查询到工序"
              :row-key="getRowKey"
              @selection-change="selectProcedures"
              height="100px"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="工序名称"
                fixed
                width="250px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="code" label="编号"></el-table-column>
              <!-- <el-table-column
                prop="productBizType"
                label="服务环节"
                :formatter="formatProductBizType"
              ></el-table-column> -->
              <el-table-column label="适用部位" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatCascadeMultiple('repairParts', scope.row.part) }}
                </template>
              </el-table-column>
              <el-table-column prop="consumption" label="劳务消耗"></el-table-column>
              <el-table-column
                prop="tools"
                label="工具配置"
                :formatter="formatTools"
              ></el-table-column>
            </el-table>
            <div slot="footer" class="c-flex c-flex-between c-flex-item">
              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="procedure.fpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="procedure.fpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="procedure.fpi.total"
              ></el-pagination>
              <div class="c-flex">
                <el-button type="primary" @click="addProcedures">确 定</el-button>
                <el-button @click="cancelProcedures">取 消</el-button>
              </div>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="适用范围" name="scope">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openScope">
                添加范围
              </el-button>
            </div>
          </div>
          <el-table ref="addedTable" :data="formData.scope" border class="c-m-t-10">
            <el-table-column label="省">
              <template slot-scope="scope">
                {{ formatProvinces(scope.row.province) }}
              </template>
            </el-table-column>
            <el-table-column label="市">
              <template slot-scope="scope">
                {{ formatCitys(scope.row.city) }}
              </template>
            </el-table-column>
            <el-table-column label="区" width="250" show-overflow-tooltip>
              <template slot-scope="scope" style="width:100%">
                {{ formatDistricts(scope.row.district) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="partnerIds"
              label="伙伴"
              :formatter="formatPartners"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column fixed="right" width="150" label="操作">
              <template slot-scope="scope">
                <el-button @click="scopeEdit(scope.row, scope.$index)" size="mini">
                  编辑
                </el-button>
                <el-button @click="scopeDelete(scope.row, scope.$index)" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="适用范围" :visible.sync="scope.open" @close="cancelScope">
            <el-form
              ref="scopeFormData"
              :model="scope.formData"
              :rules="rules"
              label-width="90px"
              label-position="left"
            >
              <el-form-item label="省市区" prop="area">
                <el-cascader
                  :options="area.options"
                  :props="area.props"
                  v-model="scope.formData.area"
                  collapse-tags
                  clearable
                  @visible-change="getST"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="伙伴">
                <el-select v-model="scope.formData.partnerIds" multiple clearable>
                  <el-option
                    v-for="item in scope.partners"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="addScope">确 定</el-button>
              <el-button @click="cancelScope">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes" v-if="false">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <!-- <el-collapse v-model="activeCollapse">
          <el-collapse-item name="1">
            <template slot="title">
              <span>依赖产品展示</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of formData.dependProList" :key="i">
                <div>
                  <i class="el-icon-box card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/Product/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p>
                    <span>型号：{{ item.code }}</span>
                  </p>
                  <p>
                    <span>单位：{{ osg.codelabel('unit', item.unit) }}</span>
                  </p>
                  <p>
                    <span>价格：{{ item.price }}元</span>
                  </p>
                  <p>
                    <span>产品类型：{{ osg.codelabel('productType', item.productType) }}</span>
                  </p>
                  <p>
                    <span>
                      业务类型：{{ osg.codelabel('productBizType', item.productBizType) }}
                    </span>
                  </p>
                  <p>
                    <span>依赖产品：{{ osg.codelabelForArray('product', item.depends) }}</span>
                  </p>
                  <p>
                    <span>子产品：{{ osg.codelabelForArray('product', item.childs) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span>子产品展示</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of formData.productList" :key="i">
                <div>
                  <i class="el-icon-box card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/Product/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p>
                    <span>型号：{{ item.code }}</span>
                  </p>
                  <p>
                    <span>单位：{{ osg.codelabel('unit', item.unit) }}</span>
                  </p>
                  <p>
                    <span>价格：{{ item.price }}元</span>
                  </p>
                  <p>
                    <span>产品类型：{{ osg.codelabel('productType', item.productType) }}</span>
                  </p>
                  <p>
                    <span>
                      业务类型：{{ osg.codelabel('productBizType', item.productBizType) }}
                    </span>
                  </p>
                  <p>
                    <span>依赖产品：{{ osg.codelabelForArray('product', item.depends) }}</span>
                  </p>
                  <p>
                    <span>子产品：{{ osg.codelabelForArray('product', item.childs) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse> -->
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';

export default {
  activated() {
    window.$this = this;
  },
  name: 'product',
  data() {
    window.$this = this;
    const selfAreajs = JSON.parse(JSON.stringify({ areaList: this.osg.areaList }));
    if (selfAreajs.areaList[0].value != '000000') {
      selfAreajs.areaList.unshift({ label: '全国', value: '000000' });
    }
    const selfAreaList = JSON.parse(JSON.stringify(this.osg.areaObj));
    if (!selfAreaList.province_list['000000']) {
      selfAreaList.province_list['000000'] = '全国';
    }
    return {
      id: null,
      tenantId: '',
      type: '',
      typeName: '产品',
      collapse: true,
      activeCollapse: '1',
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_productType: { codeId: 'productType' },
        codecfg_productBizType: { codeId: 'productBizType' },
        codecfg_unit: { codeId: 'partUnit' },
        codecfg_units: { codeId: 'UNIT' },
        codecfg_tools: { codeId: 'tools' },
        codecfg_productState: { codeId: 'productState' }
      },
      rules: this.$util.rules,
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      activeTab: 'material',
      // 关联材料
      material: {
        open: false,
        addedFpi: {
          data: []
        },
        notAddedFpi: {
          data: []
        },
        searchValue: '', //未添加材料列表搜索值
        selectedRows: []
      },
      // 所需工序
      procedure: {
        open: false,
        addedFpi: {
          data: []
        },
        fpi: {
          data: []
        },
        searchValue: '', //未添加材料列表搜索值
        selectedRows: []
      },
      laborCost: 0, //产品成本
      laborFee: 0, //产品单价
      // 适用范围
      scope: {
        open: false,
        formData: {
          area: [],
          province: [],
          city: [],
          district: [],
          partnerIds: []
        },
        partners: [] //所选省市区下的伙伴
      },
      //地址级联
      area: {
        props: {
          multiple: true
        },
        options: selfAreajs.areaList
      },
      loginOrgId: '' //登录用户组织id 用来判断是否有权限修改
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    this.loginOrgId = JSON.parse(sessionStorage['loginAccount']).orgId;
    // 当前用户tenantId
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;

    this.osg.getFields('product', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
    this.getWorkflowDef();
    this.getPartners();
    this.getProduct();
  },
  methods: {
    formatCascadeMultiple(option, array) {
      if (!array) return;
      let string = '';
      // 多选级联 有几个循环几次
      for (let arr of array) {
        let str = '';
        let opts = this.$util.deepCopy(this.options[option]);
        //有几级循环几次
        for (let i = 0; i < arr.length; i++) {
          for (let opt of opts) {
            if (opt.value == arr[i]) {
              str += (opt.label || opt.name) + '/';
              opts = this.$util.deepCopy(opt.children);
              break;
            }
          }
        }
        string += str.slice(0, str.length - 1) + '、';
      }

      return string.slice(0, string.length - 1);
    },
    formatProductState(val) {
      return this.osg.codelabel('productState', val);
    },
    formatProvinces(value) {
      let str = '';
      for (var item of value) {
        str += selfAreaList.province_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatCitys(value) {
      let str = '';
      for (var item of value) {
        str += selfAreaList.city_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatDistricts(value) {
      let str = '';
      for (var item of value) {
        str += selfAreaList.county_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    formatUnits(row, column, cellValue) {
      return this.osg.codelabel('units', cellValue);
    },
    formatPartners(row, column, cellValue) {
      return this.osg.codelabelForArray('partners', cellValue);
    },
    formatProductBizType(row, column, cellValue) {
      return this.osg.codelabel('productBizType', cellValue);
    },
    formatTools(row, column, cellValue) {
      return this.osg.codelabel('tools', cellValue);
    },
    pageSizeChange(pageSize) {
      if (this.material.open) {
        this.material.notAddedFpi.rows = pageSize;
        this.getNotAddedMaterials();
      } else {
        this.procedure.fpi.rows = pageSize;
        this.getProcedures();
      }
    },
    pageChange(currentPage) {
      if (this.material.open) {
        this.material.notAddedFpi.page = currentPage;
        this.getNotAddedMaterials();
      } else {
        this.procedure.fpi.page = currentPage;
        this.getProcedures();
      }
    },
    getData() {
      this.osg.ajax(
        `basic/product/findById/${this.id}.do`,
        {},
        res => {
          let row = res.entity;
          row.exts = row.exts || {};
          this.$util.renderExtField(this.extFields, row);
          row.image = JSON.parse(row.image);
          row.materials = row.materials || [];
          row.scope = row.scope || [];

          // 区分产品/备件
          if (this.tenantId != '1340835581184723420') {
            this.type = row.productType;
            if (this.type == '3') {
              this.typeName = '备件';
              let arr = [];
              for (let obj of this.options.productType) {
                if (obj.value == '3') {
                  arr.push(obj);
                }
              }
              this.options.productType = arr;
            } else {
              this.typeName = '产品';
              let arr = [];
              for (let obj of this.options.productType) {
                if (obj.value != '3') {
                  arr.push(obj);
                }
              }
              this.options.productType = arr;
            }
          }
          this.formData = row;
          this.getAddedMaterials();
          this.getAddedProcedures();
          //获取属性修改记录
          this.getHistory();
        },
        {
          noload: true
        }
      );
    },
    doSave(type) {
      let params = this.$util.deepCopy(this.formData);
      if (
        this.tenantId == '1340835581184723420' &&
        params.orgId &&
        this.loginOrgId != params.orgId &&
        this.loginOrgId != '0'
      ) {
        this.osg.alert('没有权限修改');
        return;
      }
      if (params.productState != '0') {
        this.osg.alert('当前' + this.typeName + '状态不允许修改', () => {
          this.getData();
        });
        return;
      }
      params.image.map(item => {
        if (item.url.indexOf('blob:') != -1) {
          item.url = this.upload.downloadUrl + item.response.key;
        }
      });
      params.image = JSON.stringify(params.image);
      delete params.productList;
      delete params.dependProList;

      //保存产品材料
      let materials = [];
      for (let material of this.material.addedFpi.data) {
        materials.push({
          materialId: material._id,
          consumption: material.consumption,
          default: material.default
        });
      }
      params.materials = materials;

      //保存服务工序
      let procedures = [];
      for (let procedure of this.procedure.addedFpi.data) {
        procedures.push({
          procedureId: procedure._id,
          laborFee: procedure.laborFee,
          laborCost: procedure.laborCost,
          show: procedure.show
        });
      }
      params.procedures = procedures;

      //将适用范围和伙伴id存到product，方便后台数据过滤
      let countryUse = false;
      let orgIds = params.orgIds || [];
      for (let scope of params.scope) {
        if (scope.province.indexOf('000000') != -1) countryUse = true;
        orgIds = orgIds.concat(scope.partnerIds);
        // 数组去重
        let arr = [];
        orgIds.map(item => {
          if (arr.indexOf(item) == -1) arr.push(item);
        });
        orgIds = arr;
      }
      params.countryUse = countryUse;
      params.orgIds = orgIds;
      // 保存关联项(材料/工序/范围)时不校验必填项
      if (this.osg.validate() || type == 'relative') {
        this.$util.saveExtField(this.extFields, params);
        this.osg.ajax(
          'basic/product/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'product',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'product'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'product',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    getProduct(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'in:state|array-integer#and': '0,1',
        'ne:productType|string#and': this.tenantId == '4551453470943235290' ? '' : '3',
        productBizType: '5'
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.product = res.data;
        this.$forceUpdate();
      });
    },
    getWorkflowDef(query) {
      let params = {
        page: 1,
        rows: 20,
        'regex:title|string#or': query,
        'in:state|array-integer#and': '0,1',
        'in:templateType|string#and': 'TT3'
      };
      this.osg.ajax('workflowDef/query.do', params, res => {
        res.data.map(item => {
          item.label = item.title;
          item.value = item._id;
        });
        this.options.workflowDef = res.data;
        this.$forceUpdate();
      });
    },
    // 点击标签栏
    tabClick() {
      // switch (tab.name) {
      //   case 'procedure':
      //     this.getAddedProcedures();
      //     break;
      //   default:
      // }
    },
    /**
     * 材料
     */
    // 查询已添加的材料
    getAddedMaterials() {
      let materials = this.formData.materials || [];
      if (materials.length == 0) return;
      // 整理已添加材料的id
      let ids = [];
      for (let material of materials) {
        ids.push(material.materialId);
      }
      let params = {
        _all: '1',
        'in:_id|array#and': ids.toString()
      };
      this.osg.ajax(
        'basic/material/query.do',
        params,
        res => {
          // 往已添加材料完整对象中补数据:消耗量consumption
          let arr = [];
          for (let material of materials) {
            for (let obj of res.data) {
              if (material.materialId == obj._id) {
                obj.editable = false;
                obj.consumption = material.consumption || 0;
                obj.default = material.default || false;
                arr.push(this.$util.deepCopy(obj));
                break;
              }
            }
          }
          // 已添加材料表格赋值
          this.material.addedFpi = { data: arr };
          // 兼容safari浏览器表格
          this.$nextTick(() => {
            this.$refs.addedTable.doLayout();
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    //点击添加材料按钮
    openNotAddMaterial() {
      this.material.open = true;
      if (this.$refs.notAddedTable) this.$refs.notAddedTable.clearSelection();
      this.material.selectedRows = [];
      this.getNotAddedMaterials();
    },
    // 查询未添加的材料
    getNotAddedMaterials() {
      let materials = this.formData.materials || [];
      // 整理已添加材料的id 用作排除
      let ids = [];
      for (let material of materials) {
        ids.push(material.materialId);
      }
      let params = {
        page: this.material.notAddedFpi.page,
        rows: this.material.notAddedFpi.rows,
        'in:state|array-integer#and': '1',
        'regex:name|string#or': this.material.searchValue,
        'regex:code|string#or': this.material.searchValue,
        // 'nin:_id|array#and': ids.toString(),
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('basic/material/query.do', params, res => {
        res.data.map(item => {
          item.editable = false;
          item.consumption = 0;
        });
        this.material.notAddedFpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.notAddedTable.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 选择未添加的材料
    selectMaterials(rows) {
      if (rows) {
        this.material.selectedRows = rows;
      }
    },
    // 添加选中的1个或多个材料
    addMaterials() {
      if (this.material.selectedRows.length == 0) {
        this.osg.toast('请选择至少1项！', 'warning');
        return;
      }
      for (let material of this.material.selectedRows) {
        material.editable = false;
        material.consumption = 0;
      }
      this.material.addedFpi.data = this.material.addedFpi.data || [];
      this.material.addedFpi.data = this.material.addedFpi.data.concat(this.material.selectedRows);
      this.cancelMaterials();
      this.doSave('relative');
    },
    // 关闭添加材料弹窗 并取消已选中材料
    cancelMaterials() {
      this.material.open = false;
      this.material.searchValue = '';
      this.selectMaterials();
    },
    // 点击编辑已添加的单个材料
    materialEdit(row) {
      row.editable = true;
    },
    // 保存已添加的单个材料编辑的内容
    materialSave(row) {
      row.editable = false;
      this.doSave('relative');
    },
    // 移除已添加的单个材料编辑的内容
    materialDelete(row, i) {
      this.material.addedFpi.data.splice(i, 1);
      this.doSave('relative');
    },

    /**
     * 材料
     */
    // 查询已添加的工序
    getAddedProcedures() {
      let procedures = this.formData.procedures || [];
      if (procedures.length == 0) return;
      // 整理已添加工序的id
      let ids = [];
      for (let procedure of procedures) {
        ids.push(procedure.procedureId);
      }
      let params = {
        _all: '1',
        'in:_id|array#and': ids.toString()
      };
      this.osg.ajax(
        'biz/extForm/query/6192129160179695921.do',
        params,
        res => {
          let laborCost = 0;
          let laborFee = 0;
          // 往已添加工序完整对象中补数据:劳务价格laborFee，劳务成本laborCost
          for (let procedure of procedures) {
            for (let obj of res.data) {
              if (procedure.procedureId == obj._id) {
                Object.assign(procedure, obj);
                procedure.editable = false;
                procedure.consumption = procedure.consumption || 0;
                procedure.show = procedure.show || false;
                //计算每一道工序的劳务成本 = 劳务成本 * 劳务消耗
                laborCost += Number(procedure.laborCost || 0) * Number(procedure.consumption);
                //计算每一道工序的劳务价格 = 劳务价格 * 劳务消耗
                laborFee += Number(procedure.laborFee || 0) * Number(procedure.consumption);
                break;
              }
            }
          }

          //劳务价格总计 和 劳务成本总计
          this.laborFee = laborFee.toFixed(2);
          this.laborCost = laborCost.toFixed(2);
          // 已添加材料表格赋值
          this.procedure.addedFpi = this.$util.deepCopy({ data: procedures });

          // 兼容safari浏览器表格
          this.$nextTick(() => {
            this.$refs.addedProcedures.doLayout();
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    //点击添加工序按钮
    openProcedure() {
      this.procedure.open = true;
      if (this.$refs.procedures) this.$refs.procedures.clearSelection();
      this.procedure.selectedRows = [];
      this.getProcedures();
    },
    // 查询所有工序
    getProcedures() {
      let params = {
        page: this.procedure.fpi.page,
        rows: this.procedure.fpi.rows,
        'is:state|integer#and': 1,
        'regex:name|string#or': this.procedure.searchValue,
        'regex:code|string#or': this.procedure.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('biz/extForm/query/6192129160179695921.do', params, res => {
        res.data.map(
          item => {
            item.editable = false;
            item.laborFee = 0;
            item.laborCost = 0;
          },
          {
            noload: true
          }
        );
        this.procedure.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.procedures.doLayout();
          this.$forceUpdate();
        });
      });
    },
    getRowKey(row) {
      return row._id;
    },
    // 选择工序
    selectProcedures(rows) {
      if (rows) {
        this.procedure.selectedRows = rows;
      }
    },
    // 添加选中的1个或多个工序
    addProcedures() {
      if (this.procedure.selectedRows.length == 0) {
        this.osg.toast('请选择至少1项！', 'warning');
        return;
      }
      for (let procedure of this.procedure.selectedRows) {
        procedure.editable = false;
        procedure.laborFee = 0;
        procedure.laborCost = 0;
      }
      this.procedure.addedFpi.data = this.procedure.addedFpi.data || [];
      this.procedure.addedFpi.data = this.procedure.addedFpi.data.concat(
        this.procedure.selectedRows
      );
      this.cancelProcedures();
      this.doSave('relative');
    },
    // 关闭添加工序弹窗 并取消已选中工序
    cancelProcedures() {
      this.procedure.open = false;
      this.procedure.searchValue = '';
      this.selectProcedures();
    },
    // 点击编辑已添加的单个工序
    procedureEdit(row) {
      row.editable = true;
    },
    // 保存已添加的单个工序编辑的内容
    procedureSave(row) {
      row.editable = false;
      // row = this.$util.deepCopy(row);
      let laborFee = 0;
      let laborCost = 0;
      this.procedure.addedFpi.data.map(item => {
        item.consumption = item.consumption || 0;
        laborFee += Number(item.laborFee || 0) * Number(item.consumption);
        laborCost += Number(item.laborCost || 0) * Number(item.consumption);
      });
      laborFee = laborFee.toFixed(2);
      laborCost = laborCost.toFixed(2);
      this.formData.price = laborFee;
      this.formData.cost = laborCost;
      this.laborFee = laborFee;
      this.laborCost = laborCost;
      this.doSave('relative');
    },
    // 移除已添加的单个工序编辑的内容
    procedureDelete(row, i) {
      this.procedure.addedFpi.data.splice(i, 1);
      let laborFee = 0;
      let laborCost = 0;
      this.procedure.addedFpi.data.map(item => {
        item.consumption = item.consumption || 0;
        laborFee += Number(item.laborFee || 0) * Number(item.consumption);
        laborCost += Number(item.laborCost || 0) * Number(item.consumption);
      });
      laborFee = laborFee.toFixed(2);
      laborCost = laborCost.toFixed(2);
      this.formData.price = laborFee;
      this.formData.cost = laborCost;
      this.laborFee = laborFee;
      this.laborCost = laborCost;
      this.doSave('relative');
    },

    /**
     * 适用范围
     */
    scopeEdit(row, index) {
      this.scope.formData = this.$util.deepCopy(row);
      this.scope.index = index;
      this.getST();
      this.scope.open = true;
    },
    scopeDelete(row, index) {
      this.formData.scope.splice(index, 1);
      this.doSave('relative');
    },
    openScope() {
      this.cancelScope();
      this.scope.open = true;
    },
    addScope() {
      if (
        this.scope.formData.province.indexOf('000000') == -1 &&
        this.scope.formData.partnerIds.length == 0
      ) {
        this.osg.toast('请选择伙伴');
        return;
      }
      if (this.scope.index || this.scope.index == 0) {
        this.formData.scope[this.scope.index] = this.scope.formData;
      } else {
        this.formData.scope.push(this.scope.formData);
      }
      this.scope.open = false;
      this.doSave('relative');
    },
    cancelScope() {
      this.scope = {
        open: false,
        formData: {
          area: [],
          province: [],
          city: [],
          district: [],
          partnerIds: []
        },
        partners: []
      };
    },
    // 查询服务区域
    getST(visible) {
      //下拉框出现/隐藏时触发
      if (visible) return;
      let area = this.scope.formData.area;
      // 单独存省市区字段
      let province = [],
        city = [],
        district = [];
      for (let arr of area) {
        if (arr[0] && province.indexOf(arr[0]) == -1) province.push(arr[0]);
        if (arr[1] && city.indexOf(arr[1]) == -1) city.push(arr[1]);
        if (arr[2] && district.indexOf(arr[2]) == -1) district.push(arr[2]);
      }
      this.scope.formData.province = province;
      this.scope.formData.city = city;
      this.scope.formData.district = district;

      //当选择全国时展示所有伙伴
      if (province.indexOf('000000') != -1) {
        this.scope.partners = Object.assign({}, this.options.partners);
        this.$forceUpdate();
        // return;
      }
      var params = {
        _all: '1',
        'in:province|array#and': province.toString(),
        'in:city|array#and': city.toString(),
        'in:district|array#and': district.toString()
      };
      this.osg.ajax('basic/serviceTerritory/query.do', params, res => {
        let srIds = [];
        res.data.map(
          item => {
            if (item.relatedIds) {
              srIds = srIds.concat(item.relatedIds);
            }
          },
          {
            noload: true
          }
        );
        this.getPartnersByIds(srIds);
        // if (srIds.length > 0) {
        //   this.getPartnersByIds(srIds);
        // } else {
        //   this.scope.partners = [];
        // }
      });
    },
    // 查询服务区域下的伙伴
    getPartnersByIds(ids) {
      var params = {
        _all: '1',
        'in:_id|array#and': ids.toString(),
        'is:resourceType|string#and': 'partner',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        res => {
          let serviceCrewIds = [];
          res.data.map(item => {
            item.label = item.name;
            item.value = item.serviceCrewId;
            serviceCrewIds.push(item.serviceCrewId);
          });
          this.scope.partners = res.data;
          this.$forceUpdate();
          // // 默认全选该区域内的伙伴
          // this.$nextTick(() => {
          this.scope.formData.partnerIds = serviceCrewIds;
          //   this.$forceUpdate();
          // });
        },
        {
          noload: true
        }
      );
    },
    // 查询所有伙伴 渲染服务范围表格
    getPartners() {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:resourceType|string#and': 'partner'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.serviceCrewId;
          });
          this.options.partners = res.data;
        }
      );
    }
  },
  watch: {
    // laborCost() {
    //   this.formData.cost = this.laborCost;
    // },
    // laborFee() {
    //   this.formData.price = this.laborFee;
    // }
  }
};
</script>
<style lang="scss">
.product .c-dialog {
  min-width: 1000px !important;
}
.c-min-height-80vh {
  min-height: 80vh;
}
.product .c-dialog.c-min-width-600 {
  min-width: 600px !important;
}
.c-radio-group {
  display: flex !important;
}
</style>
